import React, {  useState } from "react";
import DateFields from "../../../Components/Fields/DateFields";
import DurationFields from "../../../Components/Fields/DurationFields";
import TimeFields from "../../../Components/Fields/TimeFields";
import SelectMatiereFields from "../../../Components/Fields/SelectMatiereFields";
import { Subject } from "../../../Objects/models/Subject";
import moment from "moment";
import Functions from "../../../Helpers/Functions";
interface Props {
  editData: {
    startTime: Date;
    endTime: Date;
    duration: number;
    subject?: Subject | null;
    [key: string]: any;
  };
  setEditData: any;
  valueDate?: any;
  setDate: React.Dispatch<React.SetStateAction<Date>>;
  isPunctualMonth: boolean;
  handleDurationChange?: (newDuration: number) => void;
  courseType: boolean;
  activeTab?: string;
  status?: string;
} 

const FormEditCourseClient = (props: Props) => {
  const {
    // valueDate,
    // setDate,
    editData,
    setEditData,
    // isPunctualMonth,
    handleDurationChange,
    courseType,
    activeTab,
    status
  } = props;

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1); 

  // const [selectedDate, setSelectedDate] = useState(
  //   moment(editData.startTime).toDate()
  // );


  const [selectedDate, setSelectedDate] = useState<Date>(
    editData.startTime ? new Date(editData.startTime) : new Date()
  );


  return (
    <div className="flex flex-col gap-4 m-4 w-full mx-auto">
      {courseType ? (
        <>
          {/* Urgent Course*/}
          <TimeFields
            value={props.editData.startTime}
            endValue={props.editData.endTime}
            date={props.editData.startTime}
            setEndTime={(end: Date) =>
              props.setEditData((prev: any) => ({ ...prev, endTime: end }))
            }
            setStartTime={(start: Date) =>
              props.setEditData((prev: any) => ({
                ...prev,
                startTime: start,
                endTime: new Date(
                  start.getTime() + Number(prev.duration) * 60 * 60 * 1000
                ),
              }))
            }
            duration={props.editData.duration}
            today={new Date()}
            label="Heure de début du cours"
          />
          <div className="relative cursor-not-allowed px-4 py-1 rounded-lg bg-inputColor shadow-dashboard-setup-input h-max">
            <label className="block lg:text-base cursor-not-allowed">
              Heure de fin du cours
            </label>
            <input
              disabled
              value={moment(props.editData.endTime).format("HH:mm")}
              className="w-full lg:text-base bg-transparent cursor-not-allowed placeholder:text-grey"
              type="text"
            />
          </div>
          <DurationFields
            value={Functions.renderDuration(editData.duration * 2)}
            duration={editData.duration}
            setDuration={(updater: number | ((prev: number) => number)) => {
              const rawDuration =
                typeof updater === "function"
                  ? updater(editData.duration)
                  : updater;
              const newDuration = Math.round(rawDuration * 4) / 4;
              const newEnd = new Date(
                editData.startTime.getTime() + newDuration * 60 * 60 * 1000
              );
              setEditData((prev: any) => ({
                ...prev,
                duration: newDuration,
                endTime: newEnd,
              }));

              if (handleDurationChange) handleDurationChange(newDuration);
            }}
            startTime={editData.startTime}
            setEndTime={(end: Date) =>
              setEditData((prev: typeof editData) => ({
                ...prev,
                endTime: end,
              }))
            }
            label="Durée du cours"
          />
        </>
      ) : (
        <>
          {/* Punctual Course*/}
          <TimeFields
            value={props.editData.startTime}
            endValue={props.editData.endTime}
            date={props.editData.startTime}
            setEndTime={(end: Date) =>
              props.setEditData((prev: any) => ({ ...prev, endTime: end }))
            }
            setStartTime={(start: Date) =>
              props.setEditData((prev: any) => ({
                ...prev,
                startTime: start,
                endTime: new Date(
                  start.getTime() + Number(prev.duration) * 60 * 60 * 1000
                ),
              }))
            }
            duration={props.editData.duration}
            today={new Date()}
            label="Heure de début du cours"
          />
          <div className="relative cursor-not-allowed px-4 py-1 rounded-lg bg-inputColor shadow-dashboard-setup-input h-max">
            <label className="block lg:text-base cursor-not-allowed">
              Heure de fin du cours
            </label>
            <input
              disabled
              value={moment(props.editData.endTime).format("HH:mm")}
              className="w-full lg:text-base bg-transparent cursor-not-allowed placeholder:text-grey"
              type="text"
            />
          </div>
          <div
            className={
              activeTab === "taken" || status === "En proposition"
                ? "pointer-events-none opacity-50"
                : ""
            }
          >
            <DateFields
              getDate={(dateString: string) => {
                const date = new Date(dateString); // convert string to Date
                setSelectedDate(date); // now type
                const newStart = moment(date)
                  .hour(moment(props.editData.startTime).hour())
                  .minute(moment(props.editData.startTime).minute())
                  .second(0)
                  .millisecond(0)
                  .toDate();

                const newEnd = new Date(
                  newStart.getTime() +
                    Number(props.editData.duration) * 60 * 60 * 1000
                );

                props.setEditData((prev: any) => ({
                  ...prev,
                  startTime: newStart,
                  endTime: newEnd,
                }));
              }}
              // value={props.editData.startTime}
              value={selectedDate}
              minDate={tomorrow}
              // minDate={moment().add(1, "day").toDate()}
              label="Jour du cours"
            />
          </div>
          <DurationFields
            value={Functions.renderDuration(editData.duration * 2)}
            duration={editData.duration}
            setDuration={(updater: number | ((prev: number) => number)) => {
              const rawDuration =
                typeof updater === "function"
                  ? updater(editData.duration)
                  : updater;
              const newDuration = Math.round(rawDuration * 4) / 4;
              const newEnd = new Date(
                editData.startTime.getTime() + newDuration * 60 * 60 * 1000
              );
              setEditData((prev: any) => ({
                ...prev,
                duration: newDuration,
                endTime: newEnd,
              }));

              if (handleDurationChange) handleDurationChange(newDuration);
            }}
            startTime={editData.startTime}
            setEndTime={(end: Date) =>
              setEditData((prev: typeof editData) => ({
                ...prev,
                endTime: end,
              }))
            }
            label="Durée du cours"
          />
        </>
      )}
      {activeTab !== "taken" && status !== "En proposition" && (
        <div className="w-full space-y-2">
          <SelectMatiereFields
            callBack={(val: Subject) =>
              setEditData((prev: any) => ({ ...prev, subject: val }))
            }
            value={editData.subject}
            placeholder="Ex : Mathématiques"
            label="Sélectionnez la matière souhaitée"
            matieres={editData.subject}
            sizes="16"
          />
        </div>
      )}
    </div>
  );
};

export default FormEditCourseClient;
